import { Box, Typography } from '@mui/material';

import { SALES_CONDITIONS } from '../../../constants/strings';

const DutyAndTaxInformation = () => (
  <Box sx={{ mt: 2 }}>
    <Typography variant='h3'>{SALES_CONDITIONS.DUTY_TAX_TITLE}</Typography>
    <Box sx={{ pt: 2 }}>
      <Typography variant={'body1'}>
        {SALES_CONDITIONS.DUTY_AND_TAX_INFO.DUTIES_AND_TAXES}
      </Typography>
    </Box>
    <Box sx={{ pt: 2 }}>
      <Typography variant={'body1'}>
        {SALES_CONDITIONS.DUTY_AND_TAX_INFO.IF_DUTIES_AND_TAXES}
      </Typography>
    </Box>
  </Box>
);

export default DutyAndTaxInformation;
